import React from "react";
import ListToolbarView, { ListToolbarViewProps, WithId } from "./ListToolbarView";

export type FilePanelListToolbarViewProps<T extends WithId> = Omit<ListToolbarViewProps<T>, "isInProjectlist">;

function FilePanelListToolbarView<T extends WithId>(props: FilePanelListToolbarViewProps<T>) {
  const className = ["file-panel-list-toolbar", props.className].filter(Boolean).join(" ");

  return <ListToolbarView {...props} className={className} isInProjectlist={false} />;
}

export default FilePanelListToolbarView;
